import { useCurrentCloudProvider } from '@labrav/common'
import React, { useMemo } from 'react'
import { HelpDrawerWithAccordion } from '@labrav/common'
import { notificationsImages } from '../../../../../common/utils/productCreationUtil'
import {
  FaqQuestion,
  FlyoutProductCreationFaqSection,
  HelpDrawerFaqItems,
} from '../../../../AddEditProductFormComponents/FlyoutProductFormHelpFaqs/ProductCreationFaqUtil'
import { CarouselWithModal } from '../../../../../common/components/CarouselWithModal/CarouselWithModal'
import { CloudType } from '../../../../../types/index'

const awsFaqItems: HelpDrawerFaqItems[] = [
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="How will I get these notifications?"
      />
    ),
    answer: (
      <div>
        You will recieve email notifications from Labra on the occurance of any
        notification event.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="Who in my team will get notified?"
      />
    ),
    answer: (
      <div>
        Only team members whose email IDs you submit will receive email
        notifications regarding the corresponding chosen events.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="What does Buyer registration complete notify me about?"
      />
    ),
    answer: (
      <div>
        Buyer registration complete notification confirmes and notifies
        regarding the completion of a buyer's registration through the buyer
        registration page form.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="What does Buyer renewal reminder notify me about?"
      />
    ),
    answer: (
      <div>
        Buyer renewal reminder will notify you if the subscription taken by any
        of your buyers is about to expire and needs to be renewed.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="What does Buyer registration pending notify me about?"
      />
    ),
    answer: (
      <div>
        Buyer registration pending notification will be sent to you when a buyer
        purchases you listing on AWS Marketplace but has not yet completed the
        buyer registration page form.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="What does Subscribe failed notify me about?"
      />
    ),
    answer: (
      <div>
        Subscribe failed notification indicates a customer’s failure in
        subscribing to a service or product.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="What does Entitlement renewed notify me about?"
      />
    ),
    answer: (
      <div>
        Entitlement renewed notification confirms the renewal of a customer’s
        access rights or privileges to a service or product.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="What does Entitlement expired notify me about?"
      />
    ),
    answer: (
      <div>
        Entitlement expired notification indicates that a customer’s access
        rights or privileges to a service or product have expired.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="What does Entitlement upgraded notify me about?"
      />
    ),
    answer: (
      <div>
        Entitlement upgraded notification indicates an upgrade in a customer’s
        access rights or privileges to a higher-tier service or product.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="What does Unsubscribe pending notify me about?"
      />
    ),
    answer: (
      <div>
        Unsubscribe pending notification lets you know that a customer’s request
        to unsubscribe from a service or product is being processed.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="What does Unsubscribe success notify me about?"
      />
    ),
    answer: (
      <div>
        Unsubscribe success notification confirms a customer’s successful
        unsubscription from a service or product.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="What does Buyer registration pending notify me about?"
      />
    ),
    answer: (
      <div>
        Buyer registration pending notification indicates that a buyer's
        registration process is pending.
      </div>
    ),
  },
]

const azureFaqItems: HelpDrawerFaqItems[] = [
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="How will I get these notifications?"
      />
    ),
    answer: (
      <div>
        You will receive email notifications from Platform on the occurrence of
        any notification event.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="Who in my team will get notified?"
      />
    ),
    answer: (
      <div>
        Only team members whose email IDs you submit will receive email
        notifications regarding the corresponding chosen events.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="What does Buyer registration complete notify me about?"
      />
    ),
    answer: (
      <div>
        Buyer registration complete notification confirmes and notifies
        regarding the completion of a buyer's registration through the buyer
        registration page form.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="What does Buyer renewal reminder notify me about?"
      />
    ),
    answer: (
      <div>
        Buyer renewal reminder will notify you if the subscription taken by any
        of your buyers is about to expire and needs to be renewed.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="What does Buyer registration pending notify me about?"
      />
    ),
    answer: (
      <div>
        Buyer registration pending notification will be sent to you when a buyer
        purchases you listing on AWS Marketplace but has not yet completed the
        buyer registration page form.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="What does Subscribe failed notify me about?"
      />
    ),
    answer: (
      <div>
        Subscribe failed notification indicates a customer’s failure in
        subscribing to a service or product.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="What does Entitlement renewed notify me about?"
      />
    ),
    answer: (
      <div>
        Entitlement renewed notification confirms the renewal of a customer’s
        access rights or privileges to a service or product.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="What does Entitlement expired notify me about?"
      />
    ),
    answer: (
      <div>
        Entitlement expired notification indicates that a customer’s access
        rights or privileges to a service or product have expired.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="What does Entitlement upgraded notify me about?"
      />
    ),
    answer: (
      <div>
        Entitlement upgraded notification indicates an upgrade in a customer’s
        access rights or privileges to a higher-tier service or product.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="What does Unsubscribe pending notify me about?"
      />
    ),
    answer: (
      <div>
        Unsubscribe pending notification lets you know that a customer’s request
        to unsubscribe from a service or product is being processed.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="What does Unsubscribe success notify me about?"
      />
    ),
    answer: (
      <div>
        Unsubscribe success notification confirms a customer’s successful
        unsubscription from a service or product.
      </div>
    ),
  },
  {
    question: (
      <FaqQuestion
        section={
          FlyoutProductCreationFaqSection.NOTIFICATIONS_BUYER_NOTIFICATIONS
        }
        question="What does Buyer registration pending notify me about?"
      />
    ),
    answer: (
      <div>
        Buyer registration pending notification indicates that a buyer's
        registration process is pending.
      </div>
    ),
  },
]

interface BuyerLifeCycleNotificationFaqsProps {
  indexModal: number
  setIndexModal: (index: number) => void
}

export const BuyerLifeCycleNotificationFaqs: React.FC<
  BuyerLifeCycleNotificationFaqsProps
> = ({ indexModal, setIndexModal }) => {
  const selectedCloud = useCurrentCloudProvider()
  const faqItems = useMemo(() => {
    return selectedCloud === CloudType.AWS ? awsFaqItems : azureFaqItems
  }, [selectedCloud])
  return (
    <HelpDrawerWithAccordion
      headerTitle="Help & FAQs - Buyer Lifecycle Notifications"
      faqItems={faqItems}
      customContent={
        <CarouselWithModal
          carouselData={notificationsImages}
          setCurrentIndex={setIndexModal}
          currentIndex={indexModal}
        />
      }
    />
  )
}
